import Vue from 'vue';

export default {

  async fetchComments({ commit }, dprId) {
    Vue.$log.debug('loading event comments for dprId', dprId);

    return Vue.axios.get(Vue.$url("comment-event?dprId=" + dprId))
      .then((rsp) => {
        commit("SET_COMMENTS", rsp.data);
        return rsp.data || [];
      });
  }
  
}